<template>
  <div class="form">
    <b-row>
      <b-col md="6">
        <b-form-group horizontal :label-cols="3" :label="$lang('姓名：')">
          <b-form-input
            type="text"
            v-model="value.name"
            name="name"
            :class="errors.has('name') && 'is-invalid'"
            v-validate="{ ...rules.name, required: requiredType }"
            :placeholder="$lang('請輸入名字')"
            :disabled="disabled"
          />
          <b-form-invalid-feedback :state="errors.has('name')">
            {{ errors.first("name") }}
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group horizontal :label-cols="3" :label="$lang('出生年份：')">
          <DatePicker
            type="year"
            v-on:input="isChild(true)"
            v-model="value.bornAt"
            name="bornAt"
            size="large"
            :class="errors.has('bornAt') && 'is-invalid'"
            v-validate="{ ...rules.birth, required: requiredType }"
            format="yyyy"
            :disabled="disabled"
          ></DatePicker>
          <b-form-invalid-feedback :state="errors.has('bornAt')">
            {{ errors.first("bornAt") }}
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group horizontal :label-cols="3" :label="$lang('性別：')">
          <b-select
            v-model="value.gender"
            name="sex"
            :class="errors.has('sex') && 'is-invalid'"
            v-validate="{ ...rules.sex, required: requiredType }"
            :placeholder="$lang('請輸入性別')"
            :disabled="disabled"
          >
            <option value="M">{{ $lang("FIELD_MALE") }}</option>
            <option value="F">{{ $lang("FIELD_FEMALE") }}</option>
          </b-select>
          <b-form-invalid-feedback :state="errors.has('sex')">
            {{ errors.first("sex") }}
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col md="6" v-if="value.hasOwnProperty('phone')">
        <b-form-group horizontal :label-cols="3" :label="$lang('電話號碼：')">
          <b-form-input
            type="text"
            v-model="value.phone"
            name="phone"
            :class="errors.has('phone') && 'is-invalid'"
            v-validate="{
              ...rules.mobile,
              mobile: value.phone,
              required: requiredType,
            }"
            :placeholder="$lang('請輸入電話號碼')"
            :disabled="disabled"
          />
          <b-form-invalid-feedback :state="errors.has('phone')">
            {{ errors.first("phone") }}
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group
          horizontal
          :label-cols="3"
          :label="$lang('FIELD_ID_NUMBER')"
        >
          <b-form-input
            type="text"
            v-model="value.idNumber"
            name="idNumber"
            :class="errors.has('idNumber') && 'is-invalid'"
            v-validate="{
              ...rules.cycling_idNumber,
              cycling_idNumber: true,
              required: requiredType,
            }"
            :placeholder="$lang('請輸入證件號碼後4位')"
            :disabled="disabled"
          />
          <b-form-invalid-feedback :state="errors.has('idNumber')">
            {{ errors.first("idNumber") }}
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group
          horizontal
          :label-cols="5"
          :label="$lang('是否需要接駁車：')"
        >
          <b-form-select
            v-model="value.isNeedCar"
            :options="options"
            :class="errors.has(`isNeedCar`) && 'is-invalid'"
            v-validate="{ required: requiredType }"
            :disabled="disabled"
            name="isNeedCar"
          ></b-form-select>
          <b-form-invalid-feedback :state="errors.has(`isNeedCar`)">
            {{ errors.first(`isNeedCar`) }}
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col v-if="false" md="12">
        <b-form-group :label="$lang('參與日期：')">
          <b-form-checkbox-group
            v-model="value.participateDate"
            :class="errors.has('participateDate') && 'is-invalid'"
            v-validate="{ required: requiredType }"
            :options="participateDate"
            name="participateDate"
            :disabled="disabled || participateDate.isCanSignUp"
          ></b-form-checkbox-group>
          <b-form-invalid-feedback :state="errors.has('participateDate')">
            {{ errors.first("participateDate") }}
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group horizontal :label-cols="3" :label="$lang('T恤尺碼：')">
          <b-select
            v-model="value.tShirtSize"
            name="tShirtSize"
            :class="errors.has('tShirtSize') && 'is-invalid'"
            v-validate="{ required: requiredType }"
            :placeholder="$lang('請輸入T恤尺碼')"
            :disabled="disabled"
          >
            <option value="S">{{ "S" }}</option>
            <option value="M">{{ "M" }}</option>
            <option value="L">{{ "L" }}</option>
            <option value="XL">{{ "XL" }}</option>
            <option value="XXL">{{ "XXL" }}</option>
          </b-select>
          <b-form-invalid-feedback :state="errors.has('tShirtSize')">
            {{ errors.first("tShirtSize") }}
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col md="12"
        ><div style="font-weight: 500">{{ $lang("新冠疫苗接種") }}</div></b-col
      >
      <b-col md="6">
        <b-form-group
          horizontal
          :label-cols="3"
          :label="$lang('第一針疫苗日期')"
        >
          <DatePicker
            type="date"
            v-model="value.firstVaccination"
            name="firstVaccination"
            size="large"
            :class="errors.has('firstVaccination') && 'is-invalid'"
            v-validate="{ required: false }"
            format="yyyy/MM/dd"
            :disabled="disabled"
          ></DatePicker>
          <b-form-invalid-feedback :state="errors.has('firstVaccination')">
            {{ errors.first("firstVaccination") }}
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group
          horizontal
          :label-cols="3"
          :label="$lang('第二針疫苗日期')"
        >
          <DatePicker
            type="date"
            v-model="value.secondVaccination"
            name="secondVaccination"
            size="large"
            :class="errors.has('secondVaccination') && 'is-invalid'"
            v-validate="{ required: false }"
            format="yyyy/MM/dd"
            :disabled="disabled"
          ></DatePicker>
          <b-form-invalid-feedback :state="errors.has('secondVaccination')">
            {{ errors.first("secondVaccination") }}
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col md="6" v-if="!disabled">
        <slot name="remove"></slot>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      default() {
        return {
          tShirtSize: "",
          firstVaccination: "",
          secondVaccination: "",
          name: "",
          gender: "M",
          phone: "",
          bornAt: "",
          idNumber: "",
          participateDate: [],
          isNeedCar: Boolean,
        };
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    rules: {
      type: Object,
    },
    requiredType: {
      type: Boolean,
    },
    participateDate: {
      type: Array,
    },
  },
  data() {
    return {
      // options: [
      //     { text: this.optionYes, value: true },
      //     { text: "否", value: false }]
    };
  },
  watch: {
    "value.bornAt"(n) {
      this.$emit("isAdultNewTeam", n);
    },
  },
  computed: {
    options() {
      return [
        { text: this.$lang("boolean.yes"), value: true },
        { text: this.$lang("boolean.no"), value: false },
      ];
    },
  },
  methods: {
    isChild(isIndividual) {
      // console.log(isIndividual);
      if (isIndividual) {
        if (this.value.bornAt != "") {
          if (
            this.value.bornAt.getFullYear() >= 1967 &&
            this.value.bornAt.getFullYear() <= 2004
          ) {
            this.$parent.getGroupings(true);
            this.$parent.isAdultNew(true);
          } else {
            this.$parent.getGroupings(false);
            this.$parent.isAdultNew(false);
          }
          if (
            this.value.bornAt.getFullYear() >= 2006 &&
            this.value.bornAt.getFullYear() <= 2008
          ) {
            this.$parent.getGrouping(true);
            this.$parent.isAdultNew(false);
          } else {
            this.$parent.getGrouping(false);
          }
        }
      }
    },
    onSubmit() {
      return new Promise((resolve, reject) => {
        this.$validator.validate().then((result) => {
          resolve(result);
        });
      });
    },
    validateErrors(field, msg) {
      this.errors.add({
        field,
        msg,
      });
    },
  },
};
</script>
